import { Stack } from '@mui/material';
import {
  EditIcon,
  SecurityUpdateGoodOutlinedIcon,
  Button,
  ButtonProps,
} from '@occc-app/design-system';

type ActionsProps = {
  toggleEditModal: () => void;
  onOpenExperienceClick: () => void;
  isUserPermittedToEdit: boolean;
  isCSRLoginEnabled: boolean;
};

export const Actions = (props: ActionsProps) => {
  const { isUserPermittedToEdit, toggleEditModal, onOpenExperienceClick, isCSRLoginEnabled } =
    props;

  const items: (ButtonProps & { label: string })[] = [];

  if (isCSRLoginEnabled) {
    items.push({
      key: 'openExperience',
      variant: 'outlined',
      label: 'OPEN EXPERIENCE',
      endIcon: <SecurityUpdateGoodOutlinedIcon />,
      onClick: onOpenExperienceClick,
    });
  }

  if (isUserPermittedToEdit) {
    items.push({
      key: 'edit',
      variant: 'contained',
      label: 'Edit',
      startIcon: <EditIcon />,
      onClick: toggleEditModal,
    });
  }

  if (!items.length) return null;

  return (
    <Stack direction={'row'} gap={2}>
      {items.map((item) => (
        <Button
          key={item.key}
          variant={item.variant}
          color='secondary'
          startIcon={item.startIcon}
          endIcon={item.endIcon}
          onClick={item.onClick}
        >
          {item.label}
        </Button>
      ))}
    </Stack>
  );
};
